import * as React from 'react';

import cx from 'classnames';

import { FocusIndicator, Props } from '~shared/components/FocusIndicator';

export type LinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href?: string;
  includeCommonStyles?: boolean;
  indicatorProps?: Pick<Props, 'notOffset' | 'isInset'>;
};

/**
 * Styles common to any link element.
 * Includes underlining, border radius, and transition.
 */
export const commonLinkStyle =
  'group relative no-underline hover:underline rounded-1 outline-none transition ease-in-out duration-150';

/** Default visual link styles; can be overridden. */
const defaultLinkStyle = 'font-400 text-cyan-700 hocus:text-cyan-600';

/**
 * Easy common link styling. Can override with custom styles as needed.
 * If a new router link component is adopted, update this component to use that
 * instead of the base anchor.
 */
export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  function Link(
    { children, includeCommonStyles, indicatorProps, ...props }: LinkProps,
    forwardedRef
  ) {
    const linkClass = cx(
      props.className
        ? [includeCommonStyles && commonLinkStyle, props.className]
        : [commonLinkStyle, defaultLinkStyle]
    );

    return (
      <a ref={forwardedRef} {...props} className={linkClass}>
        <FocusIndicator {...indicatorProps} />
        {children}
      </a>
    );
  }
);
